export default __webpack_public_path__ + "static/media/RR310_Posterior.f44b80ac.webp";